import { useStatesOptionsAbbr } from '@/utils/states';
import { Bubble } from './Bubble/Bubble';
import { Clever } from './Clever/Clever';
import { Morty } from './Morty/Morty';
import { RenderFormRewards } from './types';

export const logoClassStyle = (
  logo: string,
  height = '32px',
  width = '120px',
  backgroundSize = 'contain'
) => ({
  backgroundImage: `url('${logo}'), linear-gradient(transparent, transparent)`,
  backgroundPosition: 'left',
  backgroundSize,
  backgroundRepeat: 'no-repeat',
  height,
  width,
});

export const heroImageStyle = (heroImage: string) => ({
  backgroundImage: `url(${heroImage}), linear-gradient(transparent, transparent)`,
  backgroundPosition: 'center center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
});

export const statesOptionsAbbrWithoutAll = () => {
  const states = useStatesOptionsAbbr();
  states.shift();

  return states;
};

export const renderFormReward: RenderFormRewards = {
  bubble: (reward, report, initialRecordSearch) => (
    <Bubble
      reward={reward}
      report={report}
      initialRecordSearch={initialRecordSearch}
    />
  ),
  clever: (reward, report, initialRecordSearch, selectRewardPartner) => (
    <Clever
      reward={reward}
      report={report}
      initialRecordSearch={initialRecordSearch}
      closeReward={selectRewardPartner}
    />
  ),
  morty: (reward, report, initialRecordSearch) => (
    <Morty
      reward={reward}
      report={report}
      initialRecordSearch={initialRecordSearch}
    />
  ),
};
